import { Form } from '@shopify/hydrogen/experimental';
import clsx from 'clsx';
import { FC } from 'react';
import { useValidation } from '../../hooks/useValidation';
import { NewsletterSchema } from '../../schemas/NewsletterSchema';
import { FormWrapper } from '../forms/FormWrapper.client';

interface FormData {
  email: string;
}

interface Props {
  newsletterError?: string;
}

export const Newsletter: FC<Props> = ({ newsletterError }) => {
  const { register, errors, isValid, submit } = useValidation<FormData>(NewsletterSchema);

  return (
    <section className="py-8">
      <div className="wrapper flex flex-col items-center justify-center md:flex-row">
        <p className="mt-6 font-outfit text-2xl md:mr-4 md:mt-0">NEWS LETTER</p>
        <Form action="/newsletter" method="POST" onSubmit={submit}>
          {({ loading, error }) => (
            <FormWrapper loading={loading} error={error}>
              <div className="relative mt-2 flex items-center justify-center md:mt-0">
                <input
                  {...register('email')}
                  className={clsx(
                    'h-full rounded-none border px-2 py-[4px] focus:border-2 focus:border-link',
                    !!errors['email'] ? 'border-2 border-red' : 'border-gray',
                  )}
                  placeholder="メールアドレス"
                />
                <button
                  type="submit"
                  disabled={!isValid || loading}
                  className="h-full bg-dark px-4 py-[7px] text-sm text-white hover:opacity-80"
                >
                  登録
                </button>
                {(!!errors['email'] || newsletterError) && (
                  <div className="absolute top-[130%] w-full border border-solid border-red bg-lightRed py-2">
                    <div className="relative before:absolute before:top-[-27px] before:right-4 before:z-[2] before:border-[10px] before:border-b-[10px] before:border-transparent before:border-b-lightRed after:absolute after:top-[-28px] after:right-4 after:z-[1] after:border-[10px] after:border-b-[10px] after:border-transparent after:border-b-red">
                      <p className="text-center text-[13px] font-bold text-red">
                        {!!errors['email']
                          ? '正しいメールアドレスを入力してください'
                          : newsletterError}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </FormWrapper>
          )}
        </Form>
      </div>
      <p className="mt-4 px-8 text-center text-xs text-gray">
        メールアドレス登録で、お得なセールご案内やペット供養に関する情報をお届けします
      </p>
    </section>
  );
};
